<template>
    <v-container fluid grid-list-md align-start>
      <v-layout row wrap align-start justify-start>
        <v-flex xs12>
              <p class="text-sm-left headline">Issue #1 - PayPal button is still showing at customer information checkout page</p>
              <br>
                      Hiding script does not work with cart popups for some of the themes.
                      <br><br>

                      If you're using a mini cart that slides or pops out in your theme, you'll need to go to Online Store -> Themes -> Customize and set your cart type to "Page" (or ask your theme developer to do this).  
                      
                      <br><br>
                      You can also <a href="https://inscoder.com/contact-page/" target="+blank">hire us at US$20 (per theme)</a>


        </v-flex>        
      </v-layout>
   
      
    </v-container>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>

<script>
import axios from 'axios';

export default {
  computed: {
    count () {
    }
  },
  methods: {
  },
  created: function () {
  },
  data () {
    return {
    }
  },
  filters: {
  },
  mounted () {    
  }  
}
</script>
